import request from '@/utils/request'

export function getFlowTypes() {
    return request({
        url: '/api/realtime/flow/types',
        method: 'get'
    })
}


export function getAboutUs() {
    return request({
        url: '/api/mds/about-us',
        method: 'get'
    })
}


export function getContact() {
    return request({
        url: '/api/mds/contact',
        method: 'get'
    })
}

export function getDistribution() {
    return request({
        url: '/api/mds/distribution',
        method: 'get'
    })
}

export function getNews(params) {
    return request({
        url: '/api/mds/news',
        method: 'get',
        params: params
    })
}
export function getRecruitment() {
    return request({
        url: '/api/mds/recruitment',
        method: 'get'
    })
}


export function getService() {
    return request({
        url: '/api/mds/service',
        method: 'get'
    })
}




export function addMember(data) {
    return request({
        url: '/mem/add',
        method: 'post',
        data: data
    })
}


export function getCarousels() {
    return request({
        url: '/api/mds/carousel',
        method: 'get'
    })
}


export function getMapJson() {
    return request({
        url: '/map/json/china.json',
        method: 'get'
    })
}

export function addLeaveWord(data) {
    return request({
        url: '/api/mds/leave-word',
        method: 'post',
        data: data
    })
}


export function getNewsGroup() {
    return request({
        url: '/api/mds/news-group',
        method: 'get'
    })
}
